import { render, staticRenderFns } from "./PackagesTokens.vue?vue&type=template&id=37928acc&scoped=true"
import script from "./PackagesTokens.vue?vue&type=script&lang=js"
export * from "./PackagesTokens.vue?vue&type=script&lang=js"
import style0 from "./PackagesTokens.vue?vue&type=style&index=0&id=37928acc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37928acc",
  null
  
)

export default component.exports